<template>
    <div>
        <component :component="formData.template"
                   :is="`public-${formData.template}`"
                   :form="formData" :contact-form="contactForm">
        </component>
    </div>
</template>

<script>
import PublicSurvey from "@/Pages/Forms/PublicSurvey";
import PublicContact from "@/Pages/Forms/PublicContact";
import PublicWhitePaper from "@/Pages/Forms/PublicWhitePaper";
import PublicCostsIndicator from "@/Pages/Forms/PublicCostsIndicator";
import PublicContenderForm from "@/Pages/Forms/PublicContenderForm.vue";

export default {
    components: {
        PublicContact,
        PublicSurvey,
        PublicWhitePaper,
        PublicCostsIndicator,
        PublicContenderForm
    },
    props: {
        formData: {
            type: Object,
            required: true
        }
    },
    computed: {
        surveyForm() {
            let surveyForm = this.formData;
            delete surveyForm.contactForm;
            return surveyForm;
        },
        contactForm() {
            if (Object.keys(this.formData).includes('contactForm')) {
                this.$set(this.formData.contactForm, 'termsAndConditions', false);
                this.$set(this.formData.contactForm, 'privacyPolicy', false);
                return this.formData.contactForm;
            }
            return null;
        }
    }
}
</script>

<style lang="sass">

//Custom SW-Classes for integration on different Websites
//General
@import "resources/scss/sw-form"
</style>
